module.exports = __webpack_public_path__ + "img/uk.eb93a8c4.png";